import {
    Style
} from '@/libs/style.js';

export default (Vue) => {
    Vue.customElement('dv-capsule-chart-1', {
        template: /* html */ `
        <div class="app-monitoring-dv-capsule-chart">
            <dv-capsule-chart :config="boardConfig" style="height:100%;color:#fff;"></dv-capsule-chart>
        </div>
        `,
        props: ["config"],
        computed: {
            boardConfig: {
                get() {
                    return JSON.parse(this.config);
                }
            }
        },
        data() {
            return {
                html: ``
            }
        },
        mounted() {
            Style( /* css */ `
            .app-monitoring-dv-capsule-chart{
                height: calc(100% - 50px);
            overflow: hidden;
            padding: 5px;
            box-sizing: border-box;
            }
            `);
        }
    });

    Vue.customElement('dv-conical-column-chart-1', {
        template: /* html */ `
        <div class="app-monitoring-dv-conical-column-chart">
            <dv-conical-column-chart :config="boardConfig" style="height:100%;color:#fff;"></dv-conical-column-chart>
        </div>
        `,
        props: ["config"],
        computed: {
            boardConfig: {
                get() {
                    return JSON.parse(this.config);
                }
            }
        },
        data() {
            return {
                html: ``
            }
        },
        mounted() {
            Style( /* css */ `
            .app-monitoring-dv-conical-column-chart{
                height: calc(100% - 50px);
            overflow: hidden;
            padding: 5px;
            box-sizing: border-box;
            }
            `);
        }
    });
}